import type { CompanyView } from '@voll-intelligence/domain';

import { t } from '@web/i18n';
import { EmptyHint } from '@web/ui/core/molecules';
import { CustomerCompanyPanel } from '@web/ui/core/organisms';

/**
 * Empresa tab — the linked company (`CustomerCompanyPanel`) in a narrow
 * column. A null company renders a graceful EmptyHint.
 */
export function CustomerCompanyTab({
  company,
}: Readonly<{ company: CompanyView | null }>): React.JSX.Element {
  if (company === null) {
    return <EmptyHint testId="customers-company-empty">{t('customers.company.empty')}</EmptyHint>;
  }
  return (
    <div className="max-w-prose-lg">
      <CustomerCompanyPanel company={company} />
    </div>
  );
}
